import React, { useRef, useEffect, useState } from 'react';
import { V2Carousel, V2Slide } from '@abyss/web/ui/Carousel';
import Autoplay from 'embla-carousel-autoplay';

import classNames from 'classnames';

import styles from './quotebox.module.css';

export const QuoteBox = () => {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef?.current) {
        const containerWidth = containerRef.current.offsetWidth * 0.9;

        setContainerWidth(containerWidth);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Call initially to set the width

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [containerRef]);

  const slideArray = [
    {
      image: '/assets/images/testimonial1.jpg',
      quote:
        'I am very happy with my doctors and providers with UnitedHealthcare. I was able to keep my providers that I had with the other healthcare plan.',
      name: 'Rae Lynn D.',
      info: 'UnitedHealthcare Medicare Advantage Plan member',
    },
    {
      image: '/assets/images/testimonial2.jpg',
      quote:
        'Enrolling in my plan was very easy. Very simple to do and happy with process.',
      name: 'Steve B.',
      info: 'UnitedHealthcare Medicare Advantage Plan member',
    },
    {
      image: '/assets/images/testimonial3.jpg',
      quote:
        'As a new member, it was a much better deal for me than what I was paying before with another provider.',
      name: 'Stephanie C.',
      info: 'UnitedHealthcare Medicare Advantage Plan member',
    },
  ];

  const slides = Array.from(Object.entries(slideArray), ([key, value]) => {
    return (
      <V2Slide
        className={styles.slide}
        css={{
          width: containerWidth,
          '& > *': {
            width: containerWidth,
            height: '100%',
          },
        }}
      >
        <div className={styles.slideGrid}>
          <div className={styles.slideMedia}>
            <img src={value.image} alt="portrait" />
          </div>
          <div className={styles.slideContent}>
            <div>
              <div className={styles.quoteWrap}>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="28"
                    viewBox="0 0 36 28"
                    fill="none"
                  >
                    <path
                      d="M13.2232 28H0.5V18.7434C0.5 14.9978 0.816947 12.0504 1.45084 9.90132C2.11492 7.72149 3.32234 5.77193 5.07309 4.05263C6.82385 2.33333 9.05757 0.982456 11.7743 0L14.2646 5.34211C11.729 6.20175 9.90276 7.39912 8.7859 8.93421C7.69922 10.4693 7.1257 12.511 7.06533 15.0592H13.2232V28ZM34.4586 28H21.7354V18.7434C21.7354 14.9671 22.0524 12.0044 22.6863 9.85526C23.3504 7.70614 24.5578 5.77193 26.3085 4.05263C28.0895 2.33333 30.3232 0.982456 33.0097 0L35.5 5.34211C32.9644 6.20175 31.1382 7.39912 30.0213 8.93421C28.9347 10.4693 28.3611 12.511 28.3008 15.0592H34.4586V28Z"
                      fill="#00BED5"
                    />
                  </svg>
                </div>
                <div>
                  <div className={styles.quote}>{value.quote}</div>
                  <div className={styles.meta}>
                    <div className={styles.name}>{value.name}</div>
                    <div>{value.info}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </V2Slide>
    );
  });

  return (
    <div className={styles.carouselWrap} ref={containerRef}>
      <V2Carousel
        label="What are UHC Medicare Plan members saying?"
        subText="UnitedHealthcare has plans designed for all budgets, stages and ages. We're America’s most chosen Medicare Advantage brand with coverage 4 out of 5 members recommend because our plans are built to be used."
        slides={slides}
        slidesPerView={1}
        emblaOverrides={{ loop: true }}
      />
    </div>
  );
};
